import { gql } from '@apollo/client';

export const ADD_NEW_RESOURCE = gql`
  mutation AddResource($input: Resource) {
    addResource(input: $input) {
      result
    }
  }
`;

export const UPDATE_RESOURCE = gql`
  mutation UpdateResource($input: UpdateResourceDetails) {
    updateResource(input: $input) {
      result
    }
  }
`;

export const GET_RESOURCE = gql`
  query resource($input: ResourceQuery) {
    resource(input: $input) {
      id
      type
      isInternal
      firstName
      lastName
      phoneNumber
      email
      isChiefChc
      company
      discipline
      employeeId
    }
  }
`;

export const SEARCH_MEMBERS = gql`
  query SearchMembers($input: String!) {
    searchMembers(input: $input) {
      id
      displayName
      firstName
      lastName
      phoneNumber
      email
    }
  }
`;

export const SEARCH_EMPLOYEE = gql`
  query SearchEmployee($input: String!) {
    searchEmployee(input: $input) {
      id
      displayName
      firstName
      lastName
      phoneNumber
      email
    }
  }
`;

export const typeOptions = [
    { value: 'Hearing Commissioner', label: 'Hearing Commissioner' },
    { value: 'Hearing Commissioner - ADR', label: 'Hearing Commissioner - ADR' },
    { value: 'Hearing Coordinator', label: 'Hearing Coordinator' },
    { value: 'SME', label: 'SME' },
    { value: 'Legal Counsel', label: 'Legal Counsel' },
    { value: 'Editor', label: 'Editor' },
  ];